import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

var base = 'cards'
AdminRouter.addRoute({
  path: `/${base}`,
  name: `${base}`,
  component: () => import('./CardsIndex.vue'),
  meta: {
    auth: true,
  },
})

AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./AddCard.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 20,
  header: ($vm) => $vm.$t(`general.menu_settings`),
  text: ($vm) => $vm.$t('account.card.title'),
  route: {
    name: `${base}`,
  },
  icon: 'icon-credit-card',
  permission: () => true,
})

messageGroups.push('account')
